import React, { Component } from 'react';
import _ from 'lodash';
import { Link, withRouter } from 'react-router-dom';
import {
    InfoLabel, Icon, Loader, Tooltip, FormattedDateRange
} from '@jutro/components';

import PropTypes from 'prop-types';
// import { SelectProducerCode } from 'gw-gateway-common-react';
import { PolicyService } from 'gw-capability-policy';
import { GatewayPolicyService, UserService } from 'gw-capability-ri-policy';
import { withAuthenticationContext } from 'gw-digital-auth-react';
import { withIntl, TranslatorContext } from '@jutro/locale';
import { Currency as CurrencyField } from 'gw-components-platform-react';
import { isCapabilityEnabled } from 'gw-portals-config-js';
import { GatewayDocumentService } from 'gw-capability-gateway-document';
import { DependencyProvider } from 'gw-portals-dependency-react';
import { PolicyBilling, LossRuns, InjuryAnalysis } from 'gw-capability-ri-policy-react';

// eslint-disable-next-line import/no-unresolved
import appConfig from 'app-config';
import { ViewModelForm } from 'gw-portals-viewmodel-react';
import CommonRoutes from '../../Common/CommonRouting';
import pageRouting from '../../Common/Claims-config.json5';
import styles from './ClaimsLanding.module.scss';
import metadata from './ClaimsLanding.metadata.json5';
import messages from '../../Claims.messages';

const { gatewayParamConfig = {} } = appConfig;
const { capabilitiesConfig } = appConfig;

const DocumentPageService = {
    getDocuments: GatewayPolicyService.getDocumentsForPolicy,
    generateUploadToken: GatewayDocumentService.generateUploadToken,
    uploadDocument: GatewayDocumentService.uploadDocument,
    removeDocument: GatewayDocumentService.removeDocument,
    downloadDocument: GatewayDocumentService.downloadDocument
};

class ClaimsLanding extends Component {
    static contextType = TranslatorContext;

    static propTypes = {
        match: PropTypes.shape({
            path: PropTypes.string,
            url: PropTypes.string
        }).isRequired,
        history: PropTypes.shape({
            push: PropTypes.func
        }).isRequired,
        authHeader: PropTypes.shape({}).isRequired,
        isLoggedIn: PropTypes.bool,
        location: PropTypes.shape({
            state: PropTypes.string,
            pathname: PropTypes.string
        }).isRequired
    };

    state = {
        currentView: undefined,
        isLoading: false,
        selectedProducerCode: 'all',
        selectedHeaderContent: messages.recentlyViewed,
        policyResponse: {},
        policyBillingData: {}
    };

    componentDidMount() {
        this.getClaimsLoadData();
    }

    getRoutesWithFeature() {
        const routes = [...pageRouting];
        this.lossRunActive(routes);
        this.injuryAnalysisActive(routes);
        return routes;
    }

    lossRunActive = (routes) => {
        if (isCapabilityEnabled({ capabilitiesConfig, capabilityName: 'claim' })) {
            const lossRunRoute = {
                path: '/lossruns',
                component: LossRuns
            };
            routes.push(lossRunRoute);
        }
    };

    injuryAnalysisActive = (routes) => {
        if (isCapabilityEnabled({ capabilitiesConfig, capabilityName: 'claim' })) {
            const iaRoute = {
                path: '/injuryanalysis',
                component: InjuryAnalysis
            };
            routes.push(iaRoute);
        }
    };

    getClaimsLoadData = async () => {
        const {
            isLoggedIn,
            authHeader,
            match: {
                params: { policyNumber }
            },
            location: { state: redirectPath, pathname }
        } = this.props;
        /* Get policy Summaries */
        const routePath = pathname && (pathname.trim().split('/') || []);
        const selectedPageFromPath = routePath[routePath.length - 1];
        const activeTile = selectedPageFromPath || redirectPath || 'recent';
        if (selectedPageFromPath == 'ri-claims') {
            return this.props.history.push('/ri-claims/tile/recent');
        }
        const defaultPolicy = policyNumber;
        await PolicyService.getAccountPolicySummaries(authHeader).then(
            (getPolicyResponse = {}) => {
                if (!_.isUndefined(getPolicyResponse) && !(Object.keys(getPolicyResponse).length === 0)) {
                    getPolicyResponse.numberOfDocuments = 0;
                    getPolicyResponse.policyNumber = _.get(getPolicyResponse[0].periods, '[0].policyId');
                    this.setState({
                        currentView: activeTile,
                        policyResponse: getPolicyResponse
                    });
                }
            }
        );
        this.setState({
            isLoading: false
        });
    };

    handleTilesOnClick = (id) => {
        this.setState({ currentView: id });
    };

    getClaimsHeader = () => {
        const {
            policyResponse
        } = this.state;

        let policyHolderName = null;
        let policyStatus = null;
        let policyNumber = null;
        let activePeriod = null;
        let billingNumber = null;
        let billingStatus = null;

        if (!_.isEmpty(policyResponse)) {
            policyResponse.find((policyData) => {
                policyData.periods.find((period) => {
                    activePeriod = period;
                    if (period.status) {
                        policyStatus = period.displayStatus;
                    }
                    if (period.displayNameExt) {
                        policyHolderName = period.displayNameExt;
                    }
                    if (period.policyId) {
                        policyNumber = period.policyId;
                    }
                    if (period.billingIdExt) {
                        billingNumber = period.billingIdExt;
                    }
                    if (period.billingStatusExt){ //FB 22533
                        billingStatus = period.billingStatusExt;
                    }
                });
            });
        }
        const statusClassName = billingStatus === 'Delinquent' ? styles.riInfoStatusAlert : styles.gwInfoStatus;

        /*  className={styles.gwTypeWithLOB}  className={styles.gwPageTitle} */
        return (
            <div>
                <div className={styles.riSubTitle}>
                    <div>
                        Account #: &nbsp;
                        <span>
                            <Link to={`/ri-billing/${policyNumber}/summary`} className={styles.riLinkDetails}>
                                {billingNumber}
                            </Link>
                        </span>
                        <InfoLabel
                            id="infoStatus"
                            size="medium"
                            className={statusClassName}
                            type="info"
                            message={billingStatus}
                        />                        
                    </div>
                    <div className={styles.riPolicyNumberDetails}>
                        Policy #: &nbsp;
                        <span>
                            <Link to={`/ri-policies/${policyNumber}/summary`} className={styles.riLinkDetails}>
                                {policyNumber}
                            </Link>
                        </span>
                        <span className={styles.riEffDateGroup}>
                            (
                            <FormattedDateRange
                                id="effectiveDate_1"
                                value={activePeriod}
                                startDate={new Date(activePeriod?.effective)}
                                endDate={new Date(activePeriod?.expiration)}
                                hideLabel
                                displayFormat="short"
                            />
                            )
                        </span>
                        <InfoLabel
                            id="infoStatus"
                            size="medium"
                            className={styles.gwInfoStatus}
                            type="info"
                            message={policyStatus}
                        />
                    </div>
                </div>
                <div className={styles.riTypeWithLOB}>
                    <div>
                        <Icon icon="call-received" className={styles.syncIcon} />
                    </div>
                    <div>
                        <h2>{policyHolderName}</h2>
                    </div>
                </div>
            </div>
        );
    };

    // getClaimsHeader = () => {

    //     const billingNo = ``;
    //     return (
    //         <>
    //              <div className={styles.gwTypeWithLOB}>
    //                 <Icon icon="call-received" className={styles.syncIcon} />
    //                 <h1 className={styles.gwPageTitle}>{messages.claims.defaultMessage} {billingNo}</h1>
    //             </div>
    //         </>
    //     );
    // };

    updateCountInfo = (type) => {
        const { policyResponse } = this.state;
        const currentCount = _.get(policyResponse, `numberOf${type}`);
        _.set(policyResponse, `numberOf${type}`, currentCount + 1);
        // alert (currentCount);
        this.setState({ policyResponse });
    };

    updateDocumentCount = (type = 'Documents') => {
        const { policyResponse, policyBillingData } = this.state;
        if (_.isEmpty(policyBillingData)) {
            return null;
        }
        const countInvoice = policyBillingData.policyPeriodBillingSummaries[0].invoiceStatements_Ext.length;
        const countEarnedPremium = policyBillingData.policyPeriodBillingSummaries[0].earnedPremiumStatements_Ext.length;
        const countPastDueInvoice = policyBillingData.policyPeriodBillingSummaries[0].pastDueInvoiceStatements_Ext.length;
        const countX = 0;
        const count = countInvoice + countEarnedPremium + countPastDueInvoice + countX;
        _.set(policyResponse, `numberOf${type}`, count);
        this.setState({ policyResponse });
    };

    render() {
        const {
            policyResponse,
            currentView,
            isLoading,
            billingIcon,
            policyBillingData
        } = this.state;
        if (isLoading) {
            return <Loader loaded={!isLoading} />;
        }

        // if (_.isEmpty(policyResponse)) {
        //     return null;
        // }

        const overrides = {
            [currentView]: {
                active: true
            },
            billing: {
                active: currentView === 'billing',
                tileIcon: billingIcon,
                visible: isCapabilityEnabled({ capabilitiesConfig, capabilityName: 'billing' })
            },
            tabClaimsTitle: {
                content: this.getClaimsHeader()
            }
        };

        const resolvers = {
            resolveComponentMap: {},
            resolveCallbackMap: {
                handleTilesOnClick: this.handleTilesOnClick
            },
            resolveClassNameMap: styles
        };
        const {
            match: { url }
        } = this.props;

        const policyDetailsData = {
            policyResponse: policyResponse
        };
        return (
            <DependencyProvider value={{ DocumentPageService }}>
                <ViewModelForm
                    uiProps={metadata.pageContent}
                    model={policyResponse}
                    overrideProps={overrides}
                    callbackMap={resolvers.resolveCallbackMap}
                    componentMap={resolvers.resolveComponentMap}
                    classNameMap={resolvers.resolveClassNameMap}
                />
                <CommonRoutes
                    steps={this.getRoutesWithFeature()}
                    basePath={url}
                    setDocumentCount={this.updateDocumentCount}
                    policyNumber={policyResponse.policyNumber}
                    policyDetailsData={policyDetailsData}
                    billingData={policyBillingData}
                />
            </DependencyProvider>
        );
    }
}

export default withRouter(withAuthenticationContext(ClaimsLanding));
